import React, { FC } from 'react';

export const LawyerNamePlaceholder: FC = () => (
  <div className="nav-name-placeholder">
    <div className="nav-name-placeholder__animated-background" />
    <div className="nav-name-placeholder__background-masker nav-name-placeholder__name-separator" />
  </div>
);
